import styled from 'styled-components';

export const TableContainer = styled.div`
  & .ant-table-cell {
    padding: 0.5rem;
  }

  & .ant-table-column-sorters {
    padding: 0.5rem;
  }

  & .state-zero {
    & .ant-table-thead,
    .ant-table-footer {
      display: none;
    }
  }

  & div.ant-table-content {
    overflow: auto hidden;
  }

  & div.ant-table-content > table > tbody > tr > td.ant-table-cell.error-row {
    background-color: ${({ theme }) => theme.colors.redLight};
  }

  & #open-orders-table,
  #open-invoices-table,
  table {
    & thead > tr > th:first-child,
    tbody > tr > td:first-child {
      padding: 0.5rem 0.5rem 0.5rem 1rem;
    }
  }
`;

interface StateZeroTableMessageProps {
  isFacelift?: boolean;
}

export const StateZeroTableMessage = styled.div<StateZeroTableMessageProps>`
  display: flex;
  flex-direction: ${({ isFacelift }) => (isFacelift ? 'row' : 'column')};
  width: 100%;
  align-items: center;
  justify-content: center;
  height: 8rem;

  & > span.title {
    font-size: 0.875rem;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.blue};
  }
  & > span.description-facelift {
    font-family: ${({ theme }) => theme.fonts.workSans};
    font-weight: 400;
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.grayDark4};

    &__bold {
      font-family: ${({ theme }) => theme.fonts.workSans};
      font-weight: 700;
      font-size: 1rem;
      color: ${({ theme }) => theme.colors.grayDark4};
    }
  }
`;

export const CustomTableCell = styled.span`
  font-size: 0.75rem;
  color: ${({ theme }) => theme.colors.graySubTitle};
  word-break: break-word;

  & > a.nf-access-key {
    font-size: 0.65rem;
  }

  & > p.structure {
    margin-bottom: 0;
  }

  & > span.unity {
    color: ${({ theme }) => theme.colors.white};
    background-color: ${({ theme }) => theme.colors.graySubTitle};
    padding: 0.5rem 0.75rem;
    font-weight: 600;
    border-radius: 5px;
  }

  & > button.trash-button {
    width: 1rem;
    border: none;
    background: none;
    outline: none;
    cursor: pointer;
  }
`;
